<script>
  import Link from '../../utils/link.html';
  import Menu from '../../components/navigation/menu';
  import Archive from '../../components/buttons/trash';
  import Plus from '../../components/buttons/plus';
  import Loader from '../../components/ui/loader.html';
  import { onMount, afterUpdate, getContext } from 'svelte';
  import { gql } from 'apollo-boost';
  import { addNotification, ICONS } from '../../utils/notifications.store';
  const history = getContext('history');

  import { LEADER, UPDATE_LEADER } from '../../graphql/leaders';

  import CoordinatorGeneral from './components/sections/leader.general';

  const client = getContext('apollo');

  const components = {
    general: CoordinatorGeneral
  };

  export let match = {};
  let loading = true;
  let leader;
  let error;
  $: current = components[match.params.section] || components['general'];

  const menu = [
    {
      id: 'general',
      label: 'Leader Details',
      link: `/leaders/view/${match.params.id}`
    }
  ];

  async function getLeader() {
    try {
      const { data } = await client.query({
        query: LEADER,
        variables: { id: match.params.id }
      });

      leader = data.leader;
      loading = false;
    } catch (e) {
      loading = false;
      error = e;
    }
  }

  function archiveLeader() {
    addNotification({
      message: `Are you sure you want to archive ${
        leader.firstName
      }? They will no longer show up in the admin, but will remain assigned to existing programs and events.`,
      icon: ICONS.CONFIRM,
      confirm: commitArchiveLeader
    });
  }

  async function commitArchiveLeader() {
    try {
      await client.mutate({
        mutation: UPDATE_LEADER,
        variables: {
          input: {
            id: leader.id,
            archived: true
          }
        }
      });

      addNotification({
        message: `Archived ${leader.firstName}`,
        icon: ICONS.SUCCESS,
        time: 3000
      });

      history.push('/leaders');
    } catch (e) {
      addNotification({
        message: `There was an error archiving ${leader.firstName}`,
        icon: ICONS.ERROR,
        time: 3000
      });
    }
  }

  onMount(getLeader);
</script>

<!-- LOADING STATE-->
{#if loading}
<Loader></Loader>
{/if}
<!-- LEADER RESULTS-->
{#if !loading}
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-6">
    <h1>{leader.firstName} {leader.lastName}</h1>
  </div>
  <div class="cell small-12 medium-6 text-right">
    <Archive on:click="{archiveLeader}" label="ARCHIVE LEADER"></Archive>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-12">
    <!--<Menu active="{match.params.section || 'general'}" items="{menu}"></Menu>-->
  </div>
</div>

<svelte:component
  this="{current}"
  bind:value="{leader}"
  id="{match.params.id}"
/>
{/if}
